<mat-form-field #textAreaForm appearance="outline" floatLabel="always" [id]="idPrefix + '-form-field'"
  [ngClass]="{ 'form-disabled' : disabled }">
  <mat-label [id]="idPrefix + '-label'">{{label}}</mat-label>
  <textarea lcTestId matInput [errorStateMatcher]="matcher" [formControl]="formControl" [id]="idPrefix + '-input'"
    [placeholder]="placeholder" [readonly]="readonly || disabled" [rows]="rows" (focusout)="onBlur()"></textarea>
  <mat-hint [id]="idPrefix + '-hint'">{{hint}}</mat-hint>
  @if (formControl && formControl.invalid) {
  <mat-error [id]="idPrefix + '-error'" [innerHTML]="errors" />
  }

  <!-- Suffix -->
  @if (suffix || suffixTemplate) {
  <div matSuffix>
    @if (suffixTemplate) {
    <template [ngTemplateOutlet]="suffixTemplate"></template>
    } @else {
    @if (suffix) {
    <span>{{suffix}}</span>
    }
    }
  </div>
  }
</mat-form-field>